export const sidebarWidth = 240;
export const headerHeight = 50;

export default {
  cssVarPrefix: 'gglass',
  defaultColorMode: 'light',
  useSystemColorMode: false,
};
